import PreloaderIcon from './preloader-icon';

export default PreloaderIcon;
